import { render, staticRenderFns } from "./StoreButton.vue?vue&type=template&id=2d04acc8&scoped=true"
import script from "./StoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StoreButton.vue?vue&type=style&index=0&id=2d04acc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04acc8",
  null
  
)

export default component.exports